import {Routes, Route} from "react-router-dom";
import Dashboard from "../pages/Dashboard/Dashboard";
import Courses from "../pages/Courses/Courses";
import CoursesClass from "../pages/CoursesClass/CoursesClass";
import UserProfile from "../pages/UserProfile/UserProfile";
import Certificates from "../pages/Certificates/Certificates";
import PrevExamPage from "../pages/PrevExamPage/PrevExamPage";
import Exams from "../pages/Exams/Exams";
import Materials from "../pages/Materials/Materials";
import {withAppContextProvider, withAppContextReady} from "../contexts/AppContext";
import Forum from "../pages/Forum/Forum";
import ForumDiscussion from "../features/Forum/ForumDiscussion/ForumDiscussion";
import Help from "../pages/Help/Help";
import Opportunities from "../pages/Opportunities/Opportunities";
import OwnCourses from "../pages/OwnCourses/OwnCourses";
import { useConfigContext } from "../contexts/ConfigContext/ConfigContextProvider"; 

const CampusRoutes = () => {
    const { jsonFeatures } = useConfigContext();
    const subscriptionLevel = jsonFeatures.subscriptionLevel;

    return (
        <Routes>
            <Route path="/dashboard" element={<Dashboard />} />
            {jsonFeatures.appRoutes.home[subscriptionLevel] && <Route path="/" element={<Dashboard />} />}
            {jsonFeatures.appRoutes.misCursos[subscriptionLevel] && <Route path="/mis-cursos" element={<OwnCourses />} />}
            <Route path="/curso/:courseId" element={<Courses />} />
            <Route path="/clase/:lessonId" element={<CoursesClass />} />
            <Route path="/clase/:lessonId/material" element={<Materials />} />
            {jsonFeatures.appRoutes.misCertificados[subscriptionLevel] && <Route path="/certificaciones" element={<Certificates />} />}
            {jsonFeatures.appRoutes.miCuenta[subscriptionLevel] && <Route path="/perfil" element={<UserProfile />} />}
            <Route path="/antes-de-evaluar/:courseName/:examId" element={<PrevExamPage />} />
            <Route path="/examen/:id" element={<Exams />} />
            {jsonFeatures.appRoutes.foro[subscriptionLevel] && <Route path="/foro" element={<Forum />} />}
            {jsonFeatures.appRoutes.foro[subscriptionLevel] && <Route path="/foro-debate/:discussionId" element={<ForumDiscussion />} />}
            {jsonFeatures.appRoutes.ayuda[subscriptionLevel] && <Route path="/ayuda" element={<Help />} />}
            {jsonFeatures.appRoutes.oportunidades[subscriptionLevel] && <Route path="/oportunidades" element={<Opportunities />} />}
        </Routes>
    );
};

export default withAppContextProvider(withAppContextReady(CampusRoutes));
